<template>
  <FaqSection :faq="faq" />
</template>

<script lang="ts">
import type { PropType } from 'vue';
import FaqSection from '~/components/organisms/Product/FaqSection.vue';
import type { FaqAccordionItem } from '~~/types/cms/AccordionItem';

export default defineComponent({
  name: 'FaqSectionCms',
  components: {
    FaqSection,
  },
  props: {
    faq: {
      type: Array as PropType<FaqAccordionItem[]>,
      required: true,
    },
  },
});
</script>
